import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { ModuleTypes } from 'types/appState';

export interface AppState {
  name?: ModuleTypes | null;
  page?: string | null;
  reasonForVisit?: string;
  tempoToken?: string | null;
  rtmToken?: string | null;
  rtmKind?: string | null;
  pendingTarget?: AppState | null;
  pccConsentWorkflowId?: number | null;
  appointmentToken?: string | null;
  appointmentPatientId?: number | null;
}

const initialState: AppState = {
  name: null,
  page: null,
  reasonForVisit: '',
};

export const appStateSettingsSlice = createSlice({
  name: 'appStateSettings',
  initialState,
  reducers: {
    appStateSettingsAction: (
      state: AppState,
      action: PayloadAction<AppState>,
    ) => ({ ...state, ...action.payload }),
  },
});

// Action creators are generated for each case reducer function
export const { appStateSettingsAction } = appStateSettingsSlice.actions;

export default appStateSettingsSlice.reducer;
